/**
 * MOD-001 — simple module rules on module_graph.rules.
 *
 * Rule shape:
 * {
 *   id: string,
 *   when: { global: "garage", equals: "excluded" },
 *   then: { action: "disable_node"|"enable_node", node_id: "n1" }
 * }
 */

function globalMap(graph) {
  const map = {};
  (graph?.globals || []).forEach((g) => {
    if (g?.key) map[g.key] = g.value;
  });
  return map;
}

function whenMatches(when, globals) {
  if (!when?.global) return false;
  const actual = globals[when.global];
  const expected = when.equals;
  return String(actual ?? "") === String(expected ?? "");
}

export function applyModuleRulesToGraph(graph, rules = graph?.rules) {
  if (!graph || !Array.isArray(rules) || !rules.length) return graph;
  const globals = globalMap(graph);
  let nodes = (graph.nodes || []).map((node) => ({
    ...node,
    data: { ...(node.data || {}) },
  }));

  rules.forEach((rule) => {
    if (!whenMatches(rule?.when, globals)) return;
    const action = rule?.then?.action;
    const nodeId = rule?.then?.node_id;
    if (!nodeId || !action) return;
    nodes = nodes.map((node) => {
      if (node.id !== nodeId) return node;
      if (action === "disable_node") {
        return { ...node, data: { ...node.data, enabled: false } };
      }
      if (action === "enable_node") {
        return { ...node, data: { ...node.data, enabled: true } };
      }
      return node;
    });
  });

  return { ...graph, nodes, rules };
}

export function applyModuleRulesToCalculation(calcData) {
  if (!calcData?.module_graph) return calcData;
  return {
    ...calcData,
    module_graph: applyModuleRulesToGraph(calcData.module_graph),
  };
}
